module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "施工人员",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "施工工艺",
      "name": "second"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName=='first'"
    }]
  }, [(_vm.sgryDetails) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%",
      "margin-right": "20px"
    },
    attrs: {
      "label": "施工人员姓名:",
      "label-width": "50px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入施工人员姓名",
      "maxlength": "20"
    },
    model: {
      value: (_vm.sgryName),
      callback: function($$v) {
        _vm.sgryName = $$v
      },
      expression: "sgryName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%",
      "margin-right": "20px"
    },
    attrs: {
      "label": "手机号码:",
      "label-width": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    model: {
      value: (_vm.sgryPhone),
      callback: function($$v) {
        _vm.sgryPhone = $$v
      },
      expression: "sgryPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%",
      "margin-right": "20px"
    },
    attrs: {
      "label": "所属城市：",
      "label-width": "40px"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.optionsList,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%",
      "margin-right": "20px"
    },
    attrs: {
      "label": "状态：",
      "label-width": "30px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.isOnline),
      callback: function($$v) {
        _vm.isOnline = $$v
      },
      expression: "isOnline"
    }
  }, _vm._l((_vm.cStatusarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("施工人员")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showSgryAdd()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dpsmjlList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }], null, false, 811300409)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Name))]
      }
    }], null, false, 2117988378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.ProvinceName) + "-" + _vm._s(scope.row.CityName))]
      }
    }], null, false, 2195203136)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.Phone))]
      }
    }], null, false, 3560085089)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.WorkName))]
      }
    }], null, false, 118327483)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工作年限",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.WorkYear))]
      }
    }], null, false, 2161533331)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.editSgry(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.onshop(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.IsOnline == 0 ? 'el-icon-upload2' : 'el-icon-download'
        }), _vm._v("\r\n              " + _vm._s(scope.row.IsOnline == 0 ? "上架" : "下架") + "\r\n            ")])]
      }
    }], null, false, 1376867090)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex1,
      "page-size": 10,
      "total": _vm.totalRowsCount1
    },
    on: {
      "current-change": _vm.handlePagingOne
    }
  })], 1)])]) : _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    staticClass: "xqyForm"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "施工人员头像：",
      "label-width": "120px"
    }
  }, [(_vm.pubHeadPortImg) ? _c('div', {
    staticStyle: {
      "width": "88px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-8px",
      "z-index": "1",
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        _vm.pubHeadPortImg = ''
      }
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.pubHeadPortImg,
      "preview-src-list": [_vm.pubHeadPortImg]
    },
    on: {
      "click": _vm.handleClickItem
    }
  })], 1) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": _vm.beforeHeadImg
    }
  }, [_c('i', {
    staticClass: "el-icon-plus icon-sgrytx"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("上传图片宽高比例应为1:1，支持的图片格式，jpg、png。")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "施工人员姓名：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入施工人员姓名"
    },
    model: {
      value: (_vm.publisherNickName),
      callback: function($$v) {
        _vm.publisherNickName = $$v
      },
      expression: "publisherNickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "手机号码：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    model: {
      value: (_vm.diaryName),
      callback: function($$v) {
        _vm.diaryName = $$v
      },
      expression: "diaryName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "工作岗位：",
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.decorationStyle),
      callback: function($$v) {
        _vm.decorationStyle = $$v
      },
      expression: "decorationStyle"
    }
  }, _vm._l((_vm.decorationStyleArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.decorationStyle == '自定义'),
      expression: "decorationStyle == '自定义'"
    }],
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "placeholder": "请输入岗位名称（最多8个字）",
      "maxlength": "8"
    },
    model: {
      value: (_vm.gangweiName),
      callback: function($$v) {
        _vm.gangweiName = $$v
      },
      expression: "gangweiName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "所属城市：",
      "label-width": "120px"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.optionDetails,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangeDetails
    },
    model: {
      value: (_vm.shengshi),
      callback: function($$v) {
        _vm.shengshi = $$v
      },
      expression: "shengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "从业年限：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入从业年限"
    },
    model: {
      value: (_vm.housingArea),
      callback: function($$v) {
        _vm.housingArea = $$v
      },
      expression: "housingArea"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("年")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "个人简介：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "纯文本框最多输入",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.rContent),
      callback: function($$v) {
        _vm.rContent = $$v
      },
      expression: "rContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sgryDetails = true
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.determineSgry()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName=='second'"
    }]
  }, [(_vm.sggyDetails) ? _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("施工工艺")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showSggyAdd()
      }
    }
  }, [_vm._v("新 增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.ygfxhkList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }], null, false, 811300409)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工艺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.title))]
      }
    }], null, false, 1628289981)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工艺简介",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.introduction))]
      }
    }], null, false, 3177053821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.editSggy(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteData(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")])]
      }
    }], null, false, 1571585252)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex2,
      "page-size": 10,
      "total": _vm.totalRowsCount2
    },
    on: {
      "current-change": _vm.handlePagingTwo
    }
  })], 1)]) : _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("新增&编辑")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.sggyDetails = true
      }
    }
  }, [_vm._v("返 回")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "xqyForm"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "工艺名称：",
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.gongyimingcheng),
      callback: function($$v) {
        _vm.gongyimingcheng = $$v
      },
      expression: "gongyimingcheng"
    }
  }, _vm._l((_vm.gymcArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gongyimingcheng == '自定义'),
      expression: "gongyimingcheng == '自定义'"
    }],
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "placeholder": "请输入工艺名称不超过6个字",
      "maxlength": "6"
    },
    model: {
      value: (_vm.gymcName),
      callback: function($$v) {
        _vm.gymcName = $$v
      },
      expression: "gymcName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "工艺简介：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入介绍内容最多输入100个汉字。",
      "maxlength": "100"
    },
    model: {
      value: (_vm.gyjj),
      callback: function($$v) {
        _vm.gyjj = $$v
      },
      expression: "gyjj"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示方式：",
      "label-width": "120px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.radioType
    },
    model: {
      value: (_vm.shopType),
      callback: function($$v) {
        _vm.shopType = $$v
      },
      expression: "shopType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("图文")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("视频")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示封面：",
      "label-width": "120px"
    }
  }, [(_vm.coverImageUrlOne) ? _c('div', {
    staticStyle: {
      "width": "88px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-8px",
      "z-index": "1",
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        _vm.coverImageUrlOne = ''
      }
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.coverImageUrlOne,
      "preview-src-list": [_vm.coverImageUrlOne]
    },
    on: {
      "click": _vm.handleClickItem
    }
  })], 1) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeCoverOfDecoration
    }
  }, [_c('i', {
    staticClass: "el-icon-plus icon-zsfm"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("上传图片宽高比例应为1:1，支持的图片格式，jpg、png。")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopType == 1),
      expression: "shopType == 1"
    }],
    attrs: {
      "label": "展示内容：",
      "label-width": "120px"
    }
  }, [_c('wjEditor', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "desc": _vm.content1
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopType == 2),
      expression: "shopType == 2"
    }],
    attrs: {
      "label": "展示内容：",
      "label-width": "120px"
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sggyDetails = true
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.determineSggy()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择装修公司",
      "visible": _vm.dialogVisibleadd,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "装修公司："
    }
  }, [
    [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择装修公司"
      },
      model: {
        value: (_vm.bbid),
        callback: function($$v) {
          _vm.bbid = $$v
        },
        expression: "bbid"
      }
    }, _vm._l((_vm.options1), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)]
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("基本信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-732bbaa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/construction.vue
// module id = 1711
// module chunks = 3